package co.uk.paxes.pinpoint.web

/**
 * AI difficulty levels.
 * Higher levels require rewarded ad to unlock.
 * 
 * Requirements: 16.1, 16.2, 16.3
 */
enum class AIDifficulty(val displayName: String, val requiresAd: Boolean) {
    EASY("Easy", false),
    MEDIUM("Medium", false),
    HARD("Hard", true),
    EXPERT("Expert", true);

    fun getHALName(): String {
        return when (this) {
            EASY -> "HAL1"
            MEDIUM -> "HAL2"
            HARD -> "HAL3"
            EXPERT -> "HAL4"
        }
    }

    fun getIcon(): String {
        return when (this) {
            EASY -> "🤖"
            MEDIUM -> "🦾"
            HARD -> "🧠"
            EXPERT -> "👾"
        }
    }
}
